import styled, { css } from 'styled-components'

import { PriceWrapper } from '@/components/Price/Price.styles'
import { Reset } from '@/lib/mixins'

export const CartWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`

export const CartTitle = styled.h2`
  text-align: center;
  max-width: 10em;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${props => props.theme.spacing.sm};
`

export const CartSectionTitle = styled.h4`
  font-size: 2rem;
  font-family: ${props => props.theme.font.secondary};
  font-weight: 300;
  color: ${props => props.theme.color.primary};
  margin-bottom: 1.75rem;
`

export const CartGroups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 56rem;
  width: 100%;
  margin: 0 auto;
`

export const CartCard = styled.div`
  position: relative;
  border: 1px solid ${props => props.theme.color.line};
  padding: 1.5rem;
`

export const CartCardInner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
`

export const CartCardMedia = styled.div`
  width: 8rem;
  height: 6rem;
  flex-shrink: 0;
  background-color: ${props => props.theme.color.light};
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const CartCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  &:not(:last-child) {
    margin-bottom: 1.75rem;
  }
`

export const CartCardHeaderContent = styled.div``

export const CartCardTitle = styled.h4`
  margin: 0;
  font-size: 1.65rem;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CartRemoveButton = styled.button`
  ${Reset('button')}
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 2.2rem;
  height: 2.2rem;
  margin-left: 0.8rem;
  border: 1px solid ${props => props.theme.color.primaryLight};
  background-color: ${props => props.theme.color.primaryLight};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 1.4em;
    height: 1.4em;
    fill: ${props => props.theme.color.primary};
  }
`

export const CartSimplePrice = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;

  ${PriceWrapper} {
    font-size: 1.75rem;
    font-weight: 600;
    color: ${props => props.theme.color.primary};
    white-space: nowrap;
  }
`

export const CartCardMeta = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 0.5rem;
  color: ${props => props.theme.color.global};
  font-size: 1.1rem;

  svg {
    width: 1.2em;
    height: 1.2em;
    margin-right: 0.75rem;
    fill: currentColor;
  }
`

export const CartRows = styled.div`
  margin-top: 0.5rem;
  border-top: 1px solid ${props => props.theme.color.line};
`

export const CartRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 3.5rem;
  padding: 0.35rem 0;
  border-bottom: 1px solid ${props => props.theme.color.line};
  gap: 1rem;
  font-weight: 500;
  font-size: 1.25rem;
`

export const CartRowName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CartRowPrice = styled.strong`
  font-size: 1.4rem;
  font-weight: 600;
  white-space: nowrap;
`

export const CartTotal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 1.5rem;
  color: ${props => props.theme.color.primaryMedium};
  font-weight: 600;

  > span:first-child {
    font-size: 1.1rem;
  }

  ${PriceWrapper} {
    font-size: 2.1rem;
    display: block;
    font-weight: 500;
    color: ${props => props.theme.color.primary};
  }
`

export const CartEmpty = styled.p`
  margin: 1rem 0 0;
  color: ${props => props.theme.color.muted};
`

export const CartHint = styled.p`
  margin: 0;
  color: ${props => props.theme.color.muted};
  font-size: 1.1rem;
  font-weight: 500;
`

export const CartGroupBody = styled.div`
  flex: 1 1 auto;
  padding: 1rem 0;
  min-width: 0;

  ${props => props.theme.accessibilityMode && css``}
`
